import { createBrowserHistory } from "history"
import { store } from 'redux/storeConfig/store'
import { formUpdateError, formUpdateSuccess } from 'redux/actions/form'

export const history = createBrowserHistory()

history.listen(() => {
  store.dispatch(formUpdateError(null))
  store.dispatch(formUpdateSuccess(null))
})
